export { default as useLockedBody } from './useLockedBody';
export * from './useLockedBody';
//# sourceMappingURL=index.js.map